import { configureStore } from '@reduxjs/toolkit';
import { combineReducers } from 'redux';
import { persistReducer, persistStore, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

// Import reducers
import articleReducer from './reducers/articleReducer';
import categoryReducer from './reducers/categoryReducer';
import authorReducer from './reducers/authorReducer';
import searchReducer from './reducers/searchReducer';
import newsletterReducer from './reducers/newsletterReducer';
import contactReducer from './reducers/contactReducer';
import authReducer from './reducers/authReducer';

// Combine reducers
const rootReducer = combineReducers({
  article: articleReducer,
  category: categoryReducer,
  author: authorReducer,
  search: searchReducer,
  newsletter: newsletterReducer,
  contact: contactReducer,
  auth: authReducer,
});

// Persist configuration
const persistConfig = {
  key: 'root',
  storage,
  whitelist: [], // Add 'article', 'category', etc. if you want to persist specific slices
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

// Configure store
const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
      immutableCheck: false,
    }),
});

const persistor = persistStore(store);

export { store, persistor };


